/* ============================================================
   Bohemians — Core JS
   Vanilla JS. No framework. Keep this small.
   ============================================================ */
(function () {
  'use strict';

  // ---------- Utility: event delegation ----------
  function on(selector, event, handler, root) {
    (root || document).addEventListener(event, function (e) {
      var target = e.target.closest(selector);
      if (target) handler(e, target);
    });
  }

  // ---------- Format money (INR default; Shopify injects currency via theme.settings) ----------
  function formatMoney(cents, currency) {
    var value = cents / 100;
    var symbol = currency === 'USD' ? '$' : '₹';
    // Luxury: no decimals when whole number, else 2dp
    var hasFraction = (value % 1) !== 0;
    return symbol + value.toLocaleString('en-IN', {
      minimumFractionDigits: hasFraction ? 2 : 0,
      maximumFractionDigits: hasFraction ? 2 : 0
    });
  }
  window.BohemiansFormatMoney = formatMoney;
  window.MehakFormatMoney = formatMoney;

  // ---------- A11y helpers ----------
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function announce(text, opts) {
    var region = document.getElementById((opts && opts.assertive) ? 'LiveAlerts' : 'LiveStatus');
    if (!region) return;
    region.textContent = '';
    setTimeout(function () { region.textContent = String(text); }, 50);
    setTimeout(function () { region.textContent = ''; }, 3000);
  }
  window.MehakAnnounce = announce;

  var FOCUSABLE_SELECTOR = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])';

  function trapFocus(panel) {
    if (!panel) return null;
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var focusable = panel.querySelectorAll(FOCUSABLE_SELECTOR);
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    panel.addEventListener('keydown', onKey);
    return function release() { panel.removeEventListener('keydown', onKey); };
  }

  // Generic overlay open/close with focus management.
  // overlay: { container, panel, onOpen, onClose, openSelector, closeSelector }
  function manageOverlay(opts) {
    var container = opts.container;
    if (!container) return { open: function(){}, close: function(){}, isOpen: function(){ return false; } };
    var releaseTrap = null;
    var openerEl = null;

    function open(trigger) {
      if (container.getAttribute('aria-hidden') === 'false') return;
      openerEl = trigger || document.activeElement;
      container.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { container.setAttribute('aria-hidden', 'false'); });
      });
      document.body.style.overflow = 'hidden';
      if (opts.onOpen) opts.onOpen(container);
      // Focus first focusable element inside the panel
      var panel = opts.panel ? opts.panel(container) : container;
      releaseTrap = trapFocus(panel);
      setTimeout(function () {
        var first = panel.querySelector('[data-overlay-initial-focus]') || panel.querySelector(FOCUSABLE_SELECTOR);
        if (first) first.focus();
      }, 50);
      // Update trigger aria-expanded
      if (openerEl && openerEl.hasAttribute && openerEl.hasAttribute('aria-expanded')) {
        openerEl.setAttribute('aria-expanded', 'true');
      }
    }

    function close() {
      if (container.getAttribute('aria-hidden') !== 'false') return;
      container.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (releaseTrap) { releaseTrap(); releaseTrap = null; }
      if (opts.onClose) opts.onClose(container);
      setTimeout(function () { container.hidden = true; }, 320);
      if (openerEl) {
        if (openerEl.hasAttribute && openerEl.hasAttribute('aria-expanded')) {
          openerEl.setAttribute('aria-expanded', 'false');
        }
        if (typeof openerEl.focus === 'function') openerEl.focus();
        openerEl = null;
      }
    }

    function isOpen() { return container.getAttribute('aria-hidden') === 'false'; }

    return { open: open, close: close, isOpen: isOpen };
  }
  window.MehakOverlay = manageOverlay;

  // ---------- Mobile nav (with focus management + iOS scroll lock + submenu toggle) ----------
  function initMobileNav() {
    var nav = document.getElementById('MobileNav');
    if (!nav) return;
    var savedScrollY = 0;

    function lockScroll() {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.top = (-savedScrollY) + 'px';
      document.body.classList.add('mobile-nav-open');
    }
    function unlockScroll() {
      document.body.classList.remove('mobile-nav-open');
      document.body.style.top = '';
      window.scrollTo(0, savedScrollY);
    }

    var ctrl = manageOverlay({
      container: nav,
      panel: function (c) { return c.querySelector('.mobile-nav__panel') || c; },
      onOpen: lockScroll,
      onClose: function () {
        unlockScroll();
        // Collapse any open sublists when drawer closes
        nav.querySelectorAll('[data-mobile-subtoggle][aria-expanded="true"]').forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
          var panelId = t.getAttribute('aria-controls');
          if (panelId) {
            var p = nav.querySelector('#' + panelId);
            if (p) p.hidden = true;
          }
        });
      }
    });
    nav.__mehakMobileNav = ctrl;

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-menu-open]');
      if (opener) { e.preventDefault(); ctrl.open(opener); return; }

      // Submenu toggle inside the drawer
      var subToggle = e.target.closest('[data-mobile-subtoggle]');
      if (subToggle) {
        e.preventDefault();
        var expanded = subToggle.getAttribute('aria-expanded') === 'true';
        var newExpanded = !expanded;
        subToggle.setAttribute('aria-expanded', String(newExpanded));
        var panelId = subToggle.getAttribute('aria-controls');
        if (panelId) {
          var panel = nav.querySelector('#' + panelId);
          if (panel) panel.hidden = !newExpanded;
        }
        return;
      }

      // Any [data-menu-close] closes the drawer
      if (e.target.closest('[data-menu-close]') || e.target.matches('.mobile-nav__scrim')) {
        ctrl.close();
        return;
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ctrl.isOpen()) ctrl.close();
    });
  }

  // ---------- Header dropdown disclosures ----------
  function initHeaderDropdowns() {
    var triggers = document.querySelectorAll('[data-dropdown-trigger]');
    var openTrigger = null;

    function resetAccs(panel) {
      if (!panel) return;
      panel.querySelectorAll('[data-dd-acc][aria-expanded="true"]').forEach(function (a) {
        a.setAttribute('aria-expanded', 'false');
      });
    }

    function closeAll(except) {
      triggers.forEach(function (t) {
        if (t === except) return;
        t.setAttribute('aria-expanded', 'false');
        var panelId = t.getAttribute('aria-controls');
        if (panelId) {
          var panel = document.getElementById(panelId);
          if (panel) { panel.hidden = true; resetAccs(panel); }
        }
      });
      if (openTrigger !== except) openTrigger = null;
    }

    // Second-level accordions inside a dropdown (Shop by Category / Collection)
    document.querySelectorAll('[data-dd-acc]').forEach(function (acc) {
      acc.addEventListener('click', function (e) {
        e.preventDefault();
        acc.setAttribute('aria-expanded', String(acc.getAttribute('aria-expanded') !== 'true'));
      });
    });

    triggers.forEach(function (trigger) {
      var panelId = trigger.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      if (!panel) return;
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        closeAll(expanded ? null : trigger);
        trigger.setAttribute('aria-expanded', String(!expanded));
        panel.hidden = expanded;
        openTrigger = expanded ? null : trigger;
      });
      // Hover support — only set aria-expanded true on mouseenter for sighted users
      var container = trigger.closest('[data-dropdown]');
      if (container) {
        container.addEventListener('mouseenter', function () {
          if (window.matchMedia('(hover: hover)').matches) {
            closeAll(trigger);
            trigger.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
            openTrigger = trigger;
          }
        });
        container.addEventListener('mouseleave', function () {
          if (window.matchMedia('(hover: hover)').matches) {
            trigger.setAttribute('aria-expanded', 'false');
            panel.hidden = true;
            resetAccs(panel);
            if (openTrigger === trigger) openTrigger = null;
          }
        });
      }
    });

    // Escape closes — staged: first collapse an open sub-accordion, then the dropdown
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var active = document.activeElement;
      var group = active && active.closest ? active.closest('.site-header__dd-group') : null;
      if (group) {
        var accBtn = group.querySelector('[data-dd-acc]');
        if (accBtn && accBtn.getAttribute('aria-expanded') === 'true') {
          accBtn.setAttribute('aria-expanded', 'false');
          accBtn.focus();
          return;
        }
      }
      if (openTrigger) {
        var t = openTrigger;
        closeAll();
        t.focus();
      }
    });
    // Outside click closes
    document.addEventListener('click', function (e) {
      if (openTrigger && !e.target.closest('[data-dropdown]')) closeAll();
    });
  }

  // ---------- Cart drawer ----------
  var cartState = { items: [], count: 0 };

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cartState = data;
        updateCartBadge(data.item_count);
        return data;
      });
  }

  function updateCartBadge(count) {
    var n = count || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.setAttribute('data-count', String(n));
      el.textContent = n > 0 ? String(n) : '';
    });
    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.setAttribute('aria-label', 'Open cart, ' + n + ' ' + (n === 1 ? 'item' : 'items'));
    });
  }

  function escapeAttr(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderCart(data) {
    var panel = document.querySelector('[data-cart-content]');
    if (!panel) return;
    var headHTML = '<header class="cart-head">'
      + '<h2 id="CartDrawerTitle" class="cart-head__title">Your cart' + (data.item_count > 0 ? ' (' + data.item_count + ')' : '') + '</h2>'
      + '<button data-cart-close aria-label="Close cart">'
        + '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
      + '</button>'
      + '</header>';

    if (!data.items || data.items.length === 0) {
      panel.innerHTML = headHTML
        + '<div class="cart-empty">'
          + '<span class="cart-empty__icon" aria-hidden="true">∞</span>'
          + '<h3 class="h3" style="margin:0;">Your cart is empty</h3>'
          + '<p>Find something you love.</p>'
          + '<a class="btn btn--primary" href="/collections/all" data-cart-close>Shop the collection</a>'
        + '</div>';
      return;
    }
    var lines = data.items.map(function (item) {
      var img = item.image ? '<img src="' + escapeAttr(item.image) + '" alt="' + escapeAttr(item.product_title) + '" loading="lazy">' : '';
      var url = item.url || '/products/' + item.handle;
      return '<div class="cart-line" data-key="' + escapeAttr(item.key) + '">'
        + '<a href="' + escapeAttr(url) + '" class="cart-line__media" data-cart-close>' + img + '</a>'
        + '<div class="cart-line__body">'
          + '<div class="cart-line__head">'
            + '<a href="' + escapeAttr(url) + '" class="cart-line__title" data-cart-close>' + escapeAttr(item.product_title) + '</a>'
            + '<span class="cart-line__price">' + formatMoney(item.final_line_price) + '</span>'
          + '</div>'
          + (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-line__variant">' + escapeAttr(item.variant_title) + '</div>' : '')
          + '<div class="cart-line__bottom">'
            + '<div class="cart-line__qty">'
              + '<button type="button" data-cart-qty="-1" aria-label="Decrease">−</button>'
              + '<span>' + item.quantity + '</span>'
              + '<button type="button" data-cart-qty="1" aria-label="Increase">+</button>'
            + '</div>'
            + '<button type="button" class="cart-line__remove" data-cart-remove aria-label="Remove ' + escapeAttr(item.product_title) + '">'
              + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>'
              + '<span>Remove</span>'
            + '</button>'
          + '</div>'
        + '</div>'
      + '</div>';
    }).join('');

    var subtotal = formatMoney(data.total_price);
    panel.innerHTML = headHTML
      + '<div class="cart-lines">' + lines + '</div>'
      + '<footer class="cart-foot">'
        + '<div class="cart-foot__row subtotal"><span>Subtotal</span><span>' + subtotal + '</span></div>'
        + '<p class="cart-foot__notes">Shipping &amp; taxes calculated at checkout.</p>'
        + '<a href="/checkout" class="btn btn--primary">Checkout · ' + subtotal + '</a>'
        + '<a href="/collections/all" class="continue-shopping" data-cart-close>Continue shopping</a>'
      + '</footer>';

    try {
      window.dispatchEvent(new CustomEvent('mehak:cart:rendered', { detail: data }));
    } catch (e) {}
  }

  var cartOverlay = null;
  function getCartOverlay() {
    if (cartOverlay) return cartOverlay;
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return null;
    cartOverlay = manageOverlay({
      container: drawer,
      panel: function (c) { return c.querySelector('.cart-drawer__panel') || c; },
      onOpen: function () { fetchCart().then(renderCart); }
    });
    return cartOverlay;
  }

  function openCart(trigger) {
    var ov = getCartOverlay(); if (!ov) return;
    ov.open(trigger);
  }
  function closeCart() {
    var ov = getCartOverlay(); if (!ov) return;
    ov.close();
  }

  function bumpCartBadge() {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.classList.remove('cart-count--bump');
      void el.offsetWidth; // force reflow
      el.classList.add('cart-count--bump');
    });
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener) { e.preventDefault(); openCart(opener); return; }
      if (e.target.closest('[data-cart-close]') || e.target.matches('.cart-drawer__scrim')) closeCart();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var ov = getCartOverlay();
        if (ov && ov.isOpen()) closeCart();
      }
    });

    // /cart page: per-line qty stepper updates input + total live
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-page-qty]');
      if (!btn) return;
      e.preventDefault();
      var line = btn.closest('[data-cart-page-line]');
      if (!line) return;
      var span = line.querySelector('[data-qty]');
      var input = line.querySelector('[data-qty-input]');
      var current = parseInt(span.textContent || '1', 10);
      var delta = parseInt(btn.getAttribute('data-page-qty'), 10);
      var next = Math.max(0, current + delta);
      span.textContent = next;
      if (input) input.value = next;
      // ajax update + re-render totals
      var key = line.getAttribute('data-key');
      fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: next })
      }).then(function (r) { return r.json(); }).then(function (data) {
        updateCartBadge(data.item_count);
        if (next === 0) line.remove();
        document.querySelectorAll('[data-page-subtotal]').forEach(function (el) { el.textContent = formatMoney(data.total_price); });
        document.querySelectorAll('[data-page-total]').forEach(function (el) { el.textContent = formatMoney(data.total_price); });
        // If empty, reload to show empty state
        if (data.item_count === 0) location.reload();
      });
    });

    // Quantity / remove inside cart drawer
    document.addEventListener('click', function (e) {
      var line = e.target.closest('[data-key]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      if (e.target.closest('[data-cart-qty]')) {
        var delta = parseInt(e.target.closest('[data-cart-qty]').getAttribute('data-cart-qty'), 10);
        var current = parseInt(line.querySelector('.cart-line__qty span').textContent, 10);
        updateLine(key, Math.max(0, current + delta));
      }
      if (e.target.closest('[data-cart-remove]')) updateLine(key, 0);
    });

    // C6 — Click on a disabled (sold-out) submit announces helpful message
    document.addEventListener('click', function (e) {
      var soldBtn = e.target.closest('form[action$="/cart/add"] [type="submit"][aria-disabled="true"], form[action$="/cart/add"] [type="submit"][disabled]');
      if (soldBtn) {
        e.preventDefault();
        e.stopPropagation();
        announce('Sold out — please email studio@mehakmakhija.com to enquire', { assertive: true });
      }
    }, true);

    // AJAX add to cart
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action$="/cart/add"]');
      if (!form) return;
      // Let Shopify's dynamic-checkout ("Buy it now") button proceed to express
      // checkout — don't hijack its submit into an AJAX add-to-cart.
      if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
      e.preventDefault();
      var data = new FormData(form);
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.setAttribute('data-loading', '1'); }
      fetch('/cart/add.js', { method: 'POST', body: data, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && res.body.description || 'Add to cart failed');
          var addedTitle = (res.body && (res.body.product_title || res.body.title)) || 'Item';
          return fetchCart().then(function (c) {
            renderCart(c); bumpCartBadge(); openCart(btn);
            announce(addedTitle + ' added to cart. Cart total: ' + c.item_count + ' ' + (c.item_count === 1 ? 'item' : 'items') + ', ' + formatMoney(c.total_price));
          });
        })
        .catch(function (err) { announce(err.message || 'Add to cart failed', { assertive: true }); })
        .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('data-loading'); } });
    });

    fetchCart();
  }

  function updateLine(key, quantity) {
    var line = document.querySelector('[data-key="' + key + '"]');
    var title = line ? (line.querySelector('.cart-line__title') || {}).textContent : '';
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantity }),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cartState = data; updateCartBadge(data.item_count); renderCart(data);
        if (quantity === 0) announce((title || 'Item') + ' removed from cart');
        else announce('Quantity updated to ' + quantity);
      });
  }

  // ---------- Reel grid autoplay (home "Shop by reels" + /pages/reels) ----------
  // Auto-play muted previews on grid tiles via IntersectionObserver.
  // Respects prefers-reduced-motion (skips autoplay).
  function initReelGridAutoplay() {
    if (!('IntersectionObserver' in window)) return;
    if (prefersReducedMotion.matches) return;

    var videos = document.querySelectorAll('.reel-card video[data-reel-video], .reel-tile video[data-reel-video], .reel-tile video[data-src]');
    if (!videos.length) return;

    // Ensure lazy-src is wired (the /pages/reels tiles use data-src for lazy load)
    videos.forEach(function (v) {
      var lazy = v.getAttribute('data-src');
      if (lazy && !v.src) v.src = lazy;
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.4) {
          v.play().catch(function(){});
        } else {
          try { v.pause(); } catch (e) {}
        }
      });
    }, { threshold: [0, 0.4, 0.7] });

    videos.forEach(function (v) { io.observe(v); });
  }

  // ---------- Reel modal ----------
  function initReels() {
    var modal = document.querySelector('[data-reel-modal]');
    if (!modal) return;
    var video = modal.querySelector('video');
    var overlay = manageOverlay({
      container: modal,
      panel: function (c) { return c.querySelector('.reel-modal__panel') || c; },
      onClose: function () { if (video) { video.pause(); video.src = ''; } }
    });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-reel-src]');
      if (trigger) {
        e.preventDefault();
        var src = trigger.getAttribute('data-reel-src');
        var poster = trigger.getAttribute('data-reel-poster') || '';
        if (video) {
          video.src = src;
          video.poster = poster;
          if (!prefersReducedMotion.matches) video.play().catch(function () {});
        }
        overlay.open(trigger);
        return;
      }
      if (e.target.closest('[data-reel-close]') || e.target.matches('.reel-modal__scrim')) overlay.close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.isOpen()) overlay.close();
    });
  }

  // ---------- Product page: variants + gallery ----------
  function initProductForm() {
    var forms = document.querySelectorAll('[data-product-form], form.product-info');
    forms.forEach(function (form) {
      var variantsJson = form.querySelector('[data-variants-json]');
      if (!variantsJson) return;
      var variants = JSON.parse(variantsJson.textContent);
      var optionSelectors = form.querySelectorAll('[data-option-index]');

      function getSelectedOptions() {
        var selected = [];
        // Skip the fallback size picker — it's a line-item property, not a real Shopify option
        form.querySelectorAll('.variant-group:not(.variant-group--size-fallback)').forEach(function (group) {
          var idx = parseInt(group.getAttribute('data-option-index'), 10);
          if (isNaN(idx)) return;
          var chosen = group.querySelector('[aria-checked="true"]');
          selected[idx] = chosen ? chosen.getAttribute('data-value') : null;
        });
        return selected;
      }

      function matchVariant() {
        var opts = getSelectedOptions();
        // If the product has no real variant options (e.g. single-color hidden, or default-only),
        // fall back to the first available variant so the CTA stays enabled.
        var hasSelection = opts.some(function (v) { return v != null; });
        if (!hasSelection) {
          return variants.find(function (v) { return v.available; }) || variants[0];
        }
        return variants.find(function (v) {
          return v.options.every(function (val, i) { return val === opts[i] || opts[i] == null; });
        });
      }

      function updateVariant() {
        var variant = matchVariant();
        var idInput = form.querySelector('[name="id"]');
        var priceEl = form.querySelector('[data-price]');
        var compareEl = form.querySelector('[data-compare-price]');
        var submitBtn = form.querySelector('[type="submit"]');
        if (variant) {
          if (idInput) idInput.value = variant.id;
          if (priceEl) priceEl.textContent = formatMoney(variant.price);
          if (compareEl) compareEl.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
          if (submitBtn) {
            // C6 — Use aria-disabled (not native disabled) so users can still
            // click and hear the sold-out announcement.
            if (variant.available) {
              submitBtn.removeAttribute('disabled');
              submitBtn.removeAttribute('aria-disabled');
              submitBtn.textContent = 'Add to cart';
            } else {
              submitBtn.setAttribute('aria-disabled', 'true');
              submitBtn.removeAttribute('disabled');
              submitBtn.textContent = 'Sold out';
            }
          }
          // Variant featured image → jump slider to matching slide (or swap first slide as fallback)
          if (variant.featured_image) {
            var src = variant.featured_image.src || variant.featured_image;
            var gallery = document.querySelector('[data-gallery]');
            if (gallery && typeof gallery.__goToSrc === 'function') {
              gallery.__goToSrc(src);
            }
          }
        } else {
          if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Unavailable'; }
        }
      }

      var currentAnnouncedPrice = null;
      form.addEventListener('click', function (e) {
        var chip = e.target.closest('.variant-chip, .color-swatch, .color-swatch-tile');
        if (!chip || chip.classList.contains('color-swatch-tile--link')) return;
        var group = chip.closest('.variant-group');
        group.querySelectorAll('[aria-checked]').forEach(function (x) {
          x.setAttribute('aria-checked', 'false');
          x.setAttribute('tabindex', '-1');
        });
        chip.setAttribute('aria-checked', 'true');
        chip.setAttribute('tabindex', '0');
        var value = chip.getAttribute('data-value') || '';
        var optionName = group.getAttribute('data-option-name') || 'Option';
        var cg = group.closest('.color-group');
        if (cg) { var cgSel = cg.querySelector('[data-color-group-selected]'); if (cgSel) cgSel.textContent = value; }
        if (chip.classList.contains('color-swatch') || chip.classList.contains('color-swatch-tile')) {
          var label = group.querySelector('[data-color-label]');
          if (label) label.textContent = value;
          announce('Color: ' + value);
        } else {
          var msg = optionName + ': ' + value;
          var v = matchVariant();
          if (v && v.price !== currentAnnouncedPrice) {
            msg += ', price ' + formatMoney(v.price);
            currentAnnouncedPrice = v.price;
          }
          announce(msg);
        }
        updateVariant();
      });

      // Roving tabindex — arrow keys move selection within radiogroup
      form.querySelectorAll('.variant-group[role="radiogroup"]').forEach(function (group) {
        group.addEventListener('keydown', function (e) {
          if (['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].indexOf(e.key) === -1) return;
          var options = Array.prototype.slice.call(group.querySelectorAll('[role="radio"]'));
          if (!options.length) return;
          var current = options.indexOf(document.activeElement);
          var next = current;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp')     next = (current - 1 + options.length) % options.length;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown')  next = (current + 1) % options.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End')  next = options.length - 1;
          e.preventDefault();
          options[next].focus();
          options[next].click();
        });
      });

      // Add-on (line-item property) live announce + price preview update
      form.addEventListener('change', function (e) {
        var addon = e.target.closest('[data-addon-price]');
        if (!addon) return;
        var name = (addon.closest('label') || {}).innerText || addon.getAttribute('name') || 'Add-on';
        announce((addon.checked ? 'Added: ' : 'Removed: ') + name.replace(/\s+/g, ' ').trim());
      });

      updateVariant();
    });
  }

  // ---------- Product gallery slider ----------
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (g) {
      var viewport = g.querySelector('[data-gallery-viewport]');
      var track = g.querySelector('[data-gallery-track]');
      if (!viewport || !track) return;
      var slides = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-slide]'));
      if (slides.length === 0) return;
      var dots = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-dot]'));
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-thumb]'));
      var counter = g.querySelector('[data-gallery-current]');
      var prevBtn = g.querySelector('[data-gallery-prev]');
      var nextBtn = g.querySelector('[data-gallery-next]');
      var index = 0;
      var count = slides.length;

      function go(i) {
        index = Math.max(0, Math.min(count - 1, i));
        track.style.transform = 'translate3d(-' + (index * 100) + '%, 0, 0)';
        dots.forEach(function (d, di) {
          var on = di === index;
          d.classList.toggle('is-active', on);
          if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
        thumbs.forEach(function (t, ti) {
          var on = ti === index;
          t.classList.toggle('is-active', on);
          if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        if (counter) counter.textContent = String(index + 1);
        if (prevBtn) prevBtn.disabled = index <= 0;
        if (nextBtn) nextBtn.disabled = index >= count - 1;
      }
      g.__galleryGo = go;

      if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-index'), 10) || 0); });
      });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-index'), 10) || 0); });
      });

      // Keyboard nav when focus inside gallery
      g.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      });

      // Touch swipe
      var startX = 0, currentX = 0, dragging = false, startedAt = 0;
      g.__swipedRecently = false;
      viewport.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        currentX = startX;
        dragging = true;
        startedAt = Date.now();
        track.classList.add('is-dragging');
      }, { passive: true });
      viewport.addEventListener('touchmove', function (e) {
        if (!dragging || !e.touches || e.touches.length !== 1) return;
        currentX = e.touches[0].clientX;
        var dx = currentX - startX;
        var w = viewport.offsetWidth || 1;
        var pct = (dx / w) * 100;
        // Resistance at edges
        if ((index === 0 && pct > 0) || (index === count - 1 && pct < 0)) pct *= 0.35;
        track.style.transform = 'translate3d(calc(-' + (index * 100) + '% + ' + pct + '%), 0, 0)';
      }, { passive: true });
      viewport.addEventListener('touchend', function () {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        var dx = currentX - startX;
        var w = viewport.offsetWidth || 1;
        var elapsed = Date.now() - startedAt;
        var threshold = (elapsed < 250) ? w * 0.12 : w * 0.28; // flick vs drag
        // Flag as swipe so the lightbox click handler can ignore this
        if (Math.abs(dx) > 10) {
          g.__swipedRecently = true;
          setTimeout(function () { g.__swipedRecently = false; }, 400);
        }
        if (dx < -threshold) go(index + 1);
        else if (dx > threshold) go(index - 1);
        else go(index); // snap back
      });

      // Variant featured_image → jump to matching slide
      g.__goToSrc = function (src) {
        if (!src) return;
        var base = String(src).split('?')[0].split('/').pop();
        for (var i = 0; i < slides.length; i++) {
          var img = slides[i].querySelector('img');
          if (img && img.src && img.src.indexOf(base) !== -1) { go(i); return; }
        }
      };

      go(0);
    });
  }

  // ---------- Image lightbox ----------
  function initLightbox() {
    var modal = document.querySelector('[data-lightbox]');
    if (!modal) return;
    var stage = modal.querySelector('[data-lightbox-stage]');
    var counter = modal.querySelector('[data-lightbox-counter]');
    var thumbs = Array.prototype.slice.call(modal.querySelectorAll('[data-lightbox-thumb]'));
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery || !stage) return;

    var sources = Array.prototype.map.call(gallery.querySelectorAll('[data-gallery-slide] img'), function (img) {
      return img.getAttribute('src');
    });
    if (sources.length === 0) return;
    var current = 0;
    var prevFocus = null;

    function render() {
      var src = sources[current];
      if (src && src.indexOf('width=') !== -1) {
        src = src.replace(/width=\d+/, 'width=2000');
      }
      stage.innerHTML = '<img src="' + src + '" alt="" draggable="false">';
      if (counter) counter.textContent = (current + 1) + ' / ' + sources.length;
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === current); });
    }

    function open(idx) {
      current = typeof idx === 'number' ? idx : 0;
      render();
      prevFocus = document.activeElement;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('[data-lightbox-close]');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (prevFocus && typeof prevFocus.focus === 'function') prevFocus.focus();
    }

    // Thumbnail clicks inside lightbox
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-index'), 10) || 0;
        current = i; render();
      });
    });
    function next() { current = (current + 1) % sources.length; render(); }
    function prev() { current = (current - 1 + sources.length) % sources.length; render(); }

    // Open on main slide click (but ignore if user just swiped)
    gallery.addEventListener('click', function (e) {
      var slide = e.target.closest('[data-gallery-slide]');
      if (!slide) return;
      if (gallery.__swipedRecently) return;
      var idx = parseInt(slide.getAttribute('data-index'), 10) || 0;
      open(idx);
    });

    modal.querySelector('[data-lightbox-close]').addEventListener('click', close);
    modal.querySelector('[data-lightbox-next]').addEventListener('click', next);
    modal.querySelector('[data-lightbox-prev]').addEventListener('click', prev);
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target === stage) close();
    });
    document.addEventListener('keydown', function (e) {
      if (modal.getAttribute('aria-hidden') !== 'false') return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'ArrowRight') { next(); return; }
      if (e.key === 'ArrowLeft') { prev(); return; }
      // Focus trap — keep Tab cycling within modal
      if (e.key === 'Tab') {
        var focusables = modal.querySelectorAll('button');
        if (focusables.length === 0) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // Swipe on lightbox
    var sx = 0, dragging = false;
    stage.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) return;
      sx = e.touches[0].clientX; dragging = true;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!dragging) return; dragging = false;
      var ex = (e.changedTouches && e.changedTouches[0].clientX) || sx;
      var dx = ex - sx;
      if (dx < -50) next(); else if (dx > 50) prev();
    });
  }

  // ---------- Sticky mobile buy bar (H6) ----------
  function initStickyBuy() {
    var bar = document.querySelector('[data-sticky-buy]');
    if (!bar) return;
    var anchor = document.querySelector('[data-product-form] [type="submit"], form.product-info [type="submit"]');
    if (!anchor) return;

    function update() {
      var rect = anchor.getBoundingClientRect();
      var ctaOff = rect.bottom < 0 || rect.top > window.innerHeight;
      var narrow = window.innerWidth < 900;
      var scrolled = window.scrollY > 320;
      var active = narrow && scrolled && ctaOff;
      bar.setAttribute('aria-hidden', active ? 'false' : 'true');
      bar.hidden = !active;
      document.body.classList.toggle('sticky-buy-active', active);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    var cta = bar.querySelector('[data-sticky-buy-cta]');
    if (cta) cta.addEventListener('click', function () {
      // Proxy to main Add to cart button
      anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { anchor.click(); }, 320);
    });
  }

  // ---------- Fallback size picker (line item property) ----------
  function initFallbackSize() {
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-fallback-size]');
      if (!chip) return;
      var group = chip.closest('.variant-group--size-fallback');
      if (!group) return;
      group.querySelectorAll('[data-fallback-size]').forEach(function (c) { c.setAttribute('aria-checked', 'false'); });
      chip.setAttribute('aria-checked', 'true');
      var label = group.querySelector('[data-fallback-size-label]');
      var input = group.querySelector('[data-fallback-size-input]');
      var val = chip.getAttribute('data-value');
      var age = chip.getAttribute('data-age');
      if (label) label.textContent = age;
      if (input) input.value = val + ' (' + age + ')';
    });
  }

  // ---------- Quantity stepper ----------
  function initQtyStepper() {
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var stepper = (minus || plus).closest('[data-qty-stepper]');
      if (!stepper) return;
      var input = stepper.querySelector('[data-qty-input]');
      if (!input) return;
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var max = parseInt(input.getAttribute('max') || '99', 10);
      var current = parseInt(input.value || String(min), 10) || min;
      var next = minus ? current - 1 : current + 1;
      next = Math.max(min, Math.min(max, next));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.addEventListener('input', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) { input.value = 1; }
    });
  }

  // ---------- Size chart modal ----------
  function initSizeChart() {
    var modal = document.querySelector('[data-size-chart]');
    if (!modal) return;
    var overlay = manageOverlay({
      container: modal,
      panel: function (c) { return c.querySelector('.size-chart__panel') || c; }
    });
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-size-chart-open]');
      if (open) { e.preventDefault(); overlay.open(open); return; }
      if (e.target.closest('[data-size-chart-close]') || e.target.matches('.size-chart__scrim')) { e.preventDefault(); overlay.close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.isOpen()) overlay.close();
    });
  }

  // ---------- Recently viewed (localStorage) ----------
  function initRecentlyViewed() {
    var STORAGE_KEY = 'bohemians:recently-viewed';
    var MAX = 12;

    function read() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
      catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    }
    function push(handle) {
      if (!handle) return;
      var list = read().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      write(list);
    }

    // Seed with current product if on product page
    if (window.BohemiansProduct && window.BohemiansProduct.handle) {
      push(window.BohemiansProduct.handle);
    }

    var section = document.querySelector('[data-recently-viewed]');
    var grid = document.querySelector('[data-recently-viewed-grid]');
    if (!section || !grid) return;

    var currentHandle = (window.BohemiansProduct && window.BohemiansProduct.handle) || '';
    var handles = read().filter(function (h) { return h && h !== currentHandle; }).slice(0, 4);
    // Skip entirely unless the user has genuinely visited at least 2 other products
    if (handles.length < 2) return;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var visible = products.filter(Boolean);
      if (visible.length < 2) return;
      grid.innerHTML = visible.map(function (p) {
        var img = p.featured_image
          ? '<img src="' + escapeAttr(p.featured_image) + '" alt="' + escapeAttr(p.title) + '" loading="lazy" width="600" height="800">'
          : '';
        var compare = (p.compare_at_price && p.compare_at_price > p.price)
          ? '<span class="compare">' + formatMoney(p.compare_at_price) + '</span>' : '';
        return '<a href="' + escapeAttr(p.url) + '" class="product-card">'
          + '<div class="product-card__media">' + img + '</div>'
          + '<div class="product-card__body">'
            + '<div class="product-card__title">' + escapeAttr(p.title) + '</div>'
            + '<div class="product-card__price">'
              + '<span class="price">' + formatMoney(p.price) + '</span>' + compare
            + '</div>'
          + '</div>'
        + '</a>';
      }).join('');
      section.hidden = false;
    });
  }

  // Pincode checker removed per client request.

  // ---------- Newsletter (Shopify customer form) ----------
  // Relies on native {% form 'customer' %} — no JS needed unless AJAX desired.

  // ---------- Reviews "Load more" ----------
  function initReviewsMore() {
    var btn = document.querySelector('[data-reviews-more]');
    var dataEl = document.querySelector('[data-reviews-data]');
    var grid = document.querySelector('[data-reviews-grid]');
    if (!btn || !dataEl || !grid) return;
    var all;
    try { all = JSON.parse(dataEl.textContent); } catch(e) { return; }
    var shown = grid.children.length;
    btn.addEventListener('click', function () {
      var batch = all.slice(shown, shown + 6);
      batch.forEach(function (r) {
        var stars = '';
        var rfull = Math.floor(r.rating || 0);
        for (var i = 1; i <= 5; i++) {
          stars += i <= rfull ? '★' : '<span class="star-empty">★</span>';
        }
        var article = document.createElement('article');
        article.className = 'review-card';
        article.innerHTML =
          '<header class="review-card__head"><span class="stars">' + stars + '</span>' +
          (r.verified ? '<span class="review-verified">✓ Verified</span>' : '') + '</header>' +
          (r.title ? '<h3 class="review-card__title">' + escapeHtml(r.title) + '</h3>' : '') +
          '<p class="review-card__text">' + escapeHtml(r.text || '') + '</p>' +
          '<footer class="review-card__foot"><strong>' + escapeHtml(r.name || '') + '</strong>' +
          (r.date ? '<span class="muted"> · ' + escapeHtml(r.date) + '</span>' : '') + '</footer>';
        grid.appendChild(article);
      });
      shown += batch.length;
      if (shown >= all.length) btn.style.display = 'none';
      else btn.textContent = 'Load more reviews (' + (all.length - shown) + ')';
    });
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---------- IntersectionObserver reveal (skipped when reduced-motion) ----------
  function initReveal() {
    if (prefersReducedMotion.matches || !('IntersectionObserver' in window)) {
      document.querySelectorAll('.fade-in-up').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    document.documentElement.classList.add('js-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.fade-in-up').forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      document.querySelectorAll('.fade-in-up').forEach(function (el) { el.classList.add('is-visible'); });
    }, 1500);
  }

  // ---------- Hero video autoplay enforcer (reduced-motion aware) ----------
  function initHeroVideo() {
    var videos = document.querySelectorAll('[data-hero-video]');
    videos.forEach(function (v) {
      if (v.closest('[data-hero-carousel]')) return; // the carousel controls its own videos
      v.muted = true;
      v.defaultMuted = true;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');

      var playing = false;
      var tryPlay = function () {
        if (prefersReducedMotion.matches) { v.pause(); v.currentTime = 0; v.style.opacity = '1'; return; }
        var p = v.play();
        if (p && typeof p.catch === 'function') {
          p.then(function () { playing = true; v.style.opacity = '1'; })
          .catch(function () {
            var resume = function () {
              if (prefersReducedMotion.matches) return cleanup();
              v.play().then(function () { playing = true; v.style.opacity = '1'; }).catch(function(){});
              cleanup();
            };
            var cleanup = function () {
              document.removeEventListener('touchstart', resume);
              document.removeEventListener('click', resume);
              document.removeEventListener('scroll', resume);
            };
            document.addEventListener('touchstart', resume, { once: true, passive: true });
            document.addEventListener('click', resume, { once: true });
            document.addEventListener('scroll', resume, { once: true, passive: true });
          });
        } else { playing = true; }
      };
      if (v.readyState >= 2) tryPlay();
      else v.addEventListener('loadeddata', tryPlay, { once: true });

      setTimeout(function () {
        if (!playing && v.paused && !prefersReducedMotion.matches) {
          v.style.transition = 'opacity .6s ease';
          v.style.opacity = '0';
        }
      }, 4000);

      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && v.paused && playing && !prefersReducedMotion.matches) tryPlay();
      });

      prefersReducedMotion.addEventListener('change', function (e) {
        if (e.matches) { v.pause(); v.currentTime = 0; }
        else { tryPlay(); }
      });
    });

    // ---- Hero mute toggle (matches Mehak React behaviour) ----
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hero-mute]');
      if (!btn) return;
      var targetSel = btn.getAttribute('data-hero-mute');
      var targets = targetSel ? document.querySelectorAll(targetSel) : document.querySelectorAll('[data-hero-video]');
      var muted = btn.getAttribute('aria-pressed') !== 'false';
      // If currently pressed (muted), unmute. Else mute.
      var newMuted = !muted;
      targets.forEach(function (v) { v.muted = newMuted; });
      btn.setAttribute('aria-pressed', String(newMuted));
      btn.setAttribute('aria-label', newMuted ? 'Unmute hero video' : 'Mute hero video');
      announce(newMuted ? 'Video muted' : 'Video unmuted');
    });
  }

  // ---------- Hero 2-slide video carousel (crossfade, arrows, pause, auto-advance) ----------
  function initHeroCarousel() {
    var root = document.querySelector('[data-hero-carousel]');
    if (!root) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    if (slides.length < 2) return;
    var prevBtn  = root.querySelector('[data-hero-prev]');
    var nextBtn  = root.querySelector('[data-hero-next]');
    var pauseBtn = root.querySelector('[data-hero-pause]');
    var statusEl = root.querySelector('[data-hero-status]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var names = ['VARQ AW25', 'The House of Bridesmaids'];

    var current = 0;
    var userPaused = false;   // explicit pause button
    var suspended = false;    // hover/focus pause of rotation
    var pending = false;      // active slide finished but advance was suppressed

    function vids(i) { return Array.prototype.slice.call(slides[i].querySelectorAll('[data-slide-video]')); }
    slides.forEach(function (s) {
      s.querySelectorAll('[data-slide-video]').forEach(function (v) {
        v.muted = true; v.defaultMuted = true; v.playsInline = true;
        v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
        v.loop = false;
      });
    });

    function playActive() {
      slides.forEach(function (s, i) {
        vids(i).forEach(function (v) {
          if (reduce.matches) { try { v.pause(); v.currentTime = 0; } catch (e) {} return; }
          if (i === current && !userPaused) {
            try { if (v.ended || v.currentTime > 0) v.currentTime = 0; } catch (e) {}
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          } else { try { v.pause(); } catch (e) {} }
        });
      });
    }

    function announce() {
      if (statusEl) statusEl.textContent = 'Slide ' + (current + 1) + ' of ' + slides.length + ': ' + (names[current] || '');
    }

    function armEndListeners() {
      pending = false;
      if (reduce.matches) return;
      vids(current).forEach(function (v) {
        v.addEventListener('ended', onActiveEnded, { once: true });
      });
    }
    var endedSet = [];
    function onActiveEnded(e) {
      if (endedSet.indexOf(e.target) === -1) endedSet.push(e.target);
      var all = vids(current);
      var done = all.every(function (v) { return v.ended; });
      if (!done) return;
      endedSet = [];
      if (userPaused || suspended || reduce.matches) { pending = true; return; }
      goTo(current + 1);
    }

    function goTo(i, opts) {
      opts = opts || {};
      var prev = current;
      current = (i + slides.length) % slides.length;
      if (current === prev && !opts.force) return;
      slides[prev].inert = true;  slides[prev].classList.remove('is-active');   // inert at fade START
      slides[current].inert = false; slides[current].classList.add('is-active');
      endedSet = [];
      playActive();
      armEndListeners();
      if (!opts.silent) announce();
    }

    // Controls
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    function setPaused(p) {
      userPaused = p;
      if (pauseBtn) {
        pauseBtn.setAttribute('aria-pressed', String(p));
        pauseBtn.setAttribute('aria-label', p ? 'Play slideshow' : 'Pause slideshow');
      }
      if (p) { vids(current).forEach(function (v) { try { v.pause(); } catch (e) {} }); }
      else { playActive(); if (pending) { pending = false; goTo(current + 1); } else { armEndListeners(); } }
    }
    if (pauseBtn) pauseBtn.addEventListener('click', function () { setPaused(!userPaused); });

    // Pause rotation on hover/focus (WCAG 2.2.2); resume on leave/blur
    root.addEventListener('mouseenter', function () { suspended = true; });
    root.addEventListener('mouseleave', function () { suspended = false; if (pending && !userPaused) { pending = false; goTo(current + 1); } });
    root.addEventListener('focusin',  function () { suspended = true; });
    root.addEventListener('focusout', function (e) {
      if (root.contains(e.relatedTarget)) return;
      suspended = false; if (pending && !userPaused) { pending = false; goTo(current + 1); }
    });

    reduce.addEventListener('change', function () { playActive(); if (!reduce.matches) armEndListeners(); });

    // Initial state: slide 0 active (markup), slide 1 inert (markup). Start playback + arm.
    slides.forEach(function (s, i) { s.inert = (i !== 0); });
    playActive();
    armEndListeners();
  }

  // ---------- Predictive search overlay (combobox pattern, dark editorial) ----------
  function initSearchOverlay() {
    var container = document.getElementById('SearchOverlay');
    if (!container) return;
    var input = container.querySelector('[data-search-input]');
    var spinner = container.querySelector('[data-search-spinner]');
    var liveZone = container.querySelector('[data-search-live]');
    var suggestions = container.querySelector('[data-search-suggestions]');
    var noResultsEl = container.querySelector('[data-search-no-results]');
    var noResultsQuery = container.querySelector('[data-search-no-results-query]');
    var recentsHost = container.querySelector('[data-search-recents]');
    var clearRecentsBtn = container.querySelector('[data-search-clear-recents]');
    var form = container.querySelector('[data-search-form]');

    var RECENTS_KEY = 'mehak:search:recents';
    function readRecents() {
      try { return JSON.parse(localStorage.getItem(RECENTS_KEY) || '[]'); }
      catch (e) { return []; }
    }
    function writeRecents(list) {
      try { localStorage.setItem(RECENTS_KEY, JSON.stringify(list.slice(0, 5))); } catch (e) {}
    }
    function addRecent(term) {
      term = (term || '').trim();
      if (!term) return;
      var list = readRecents().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
      list.unshift(term);
      writeRecents(list);
    }
    function renderRecents() {
      if (!recentsHost) return;
      var list = readRecents();
      if (clearRecentsBtn) clearRecentsBtn.hidden = list.length === 0;
      if (!list.length) {
        recentsHost.innerHTML = '<p class="search-overlay__recents-empty">No recent searches</p>';
        return;
      }
      recentsHost.innerHTML = list.map(function (t) {
        return '<button type="button" class="search-overlay__recent" data-search-recent="' + escapeAttr(t) + '">'
          + '<span class="search-overlay__recent-icon" aria-hidden="true">'
            + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>'
          + '</span>'
          + '<span>' + escapeAttr(t) + '</span>'
        + '</button>';
      }).join('');
    }

    var overlay = manageOverlay({
      container: container,
      panel: function (c) { return c.querySelector('.search-overlay__panel') || c; },
      onOpen: function () {
        renderRecents();
        setTimeout(function () { if (input) input.focus(); }, 80);
      },
      onClose: function () {
        if (input) {
          input.value = '';
          input.setAttribute('aria-expanded', 'false');
          input.removeAttribute('aria-activedescendant');  // M9
        }
        if (liveZone) { liveZone.innerHTML = ''; liveZone.hidden = true; }
        if (suggestions) suggestions.hidden = false;
        if (noResultsEl) noResultsEl.hidden = true;
        if (spinner) spinner.hidden = true;
      }
    });

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-search-open]');
      if (opener) { e.preventDefault(); overlay.open(opener); return; }
      if (e.target.closest('[data-search-close]') || e.target.matches('#SearchOverlay .search-overlay__scrim')) {
        overlay.close();
        return;
      }
      var chip = e.target.closest('[data-search-chip]');
      if (chip && input) {
        input.value = chip.getAttribute('data-search-chip') || '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
        return;
      }
      var recent = e.target.closest('[data-search-recent]');
      if (recent && input) {
        input.value = recent.getAttribute('data-search-recent') || '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
        return;
      }
      if (e.target.closest('[data-search-clear-recents]')) {
        try { localStorage.removeItem(RECENTS_KEY); } catch (err) {}
        renderRecents();
        return;
      }
      if (e.target.closest('[data-search-clear]')) {
        if (input) { input.value = ''; input.dispatchEvent(new Event('input', { bubbles: true })); input.focus(); }
        return;
      }
      // Track recent on result click
      var resultLink = e.target.closest('#SearchOverlay [data-search-result] a');
      if (resultLink && input) {
        addRecent(input.value);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.isOpen()) overlay.close();
    });

    if (!input || !liveZone) return;

    var fetchAbort = null;
    var debounceTimer = null;
    var activeIndex = -1;

    function buildResults(payload) {
      var products = (payload.resources && payload.resources.results && payload.resources.results.products) || [];

      if (!products.length) {
        liveZone.innerHTML = '';
        liveZone.hidden = true;
        if (noResultsEl) {
          if (noResultsQuery) noResultsQuery.textContent = '"' + (input.value || '').trim() + '"';
          noResultsEl.hidden = false;
        }
        announce('No results found');
        return;
      }
      if (noResultsEl) noResultsEl.hidden = true;

      var rows = products.slice(0, 10).map(function (p, i) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        var category = (p.product_type || (p.tags && p.tags[0]) || 'Apparel');
        return '<li class="search-overlay__result" role="option" id="SearchOpt-' + i + '" data-search-result data-search-href="' + escapeAttr(p.url) + '">'
          + '<a href="' + escapeAttr(p.url) + '" tabindex="-1">'
            + '<span class="search-overlay__result-thumb">'
              + (img ? '<img src="' + escapeAttr(img) + '" alt="" loading="lazy">' : '')
            + '</span>'
            + '<span class="search-overlay__result-meta">'
              + '<h4 class="search-overlay__result-title">' + escapeAttr(p.title) + '</h4>'
              + '<p class="search-overlay__result-category">' + escapeAttr(category) + '</p>'
              + '<span class="search-overlay__result-arrow"><span>View Details</span><span aria-hidden="true">→</span></span>'
            + '</span>'
          + '</a>'
        + '</li>';
      }).join('');

      liveZone.innerHTML = '<p class="search-overlay__results-count">Found ' + products.length + ' result' + (products.length === 1 ? '' : 's') + '</p>'
        + '<ul class="search-overlay__results-list" role="presentation">' + rows + '</ul>';
      liveZone.hidden = false;
      activeIndex = -1;
      announce(products.length + ' results found for ' + input.value);
    }

    function runQuery(q) {
      if (fetchAbort && typeof fetchAbort.abort === 'function') fetchAbort.abort();
      fetchAbort = ('AbortController' in window) ? new AbortController() : null;
      if (spinner) spinner.hidden = false;
      // Predictive Search API — keep params minimal. Adding `fields` filters
      // can return 0 results or non-JSON on some Shopify plans.
      var url = '/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product'
        + '&resources[limit]=10'
        + '&resources[options][unavailable_products]=last';
      var opts = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
      if (fetchAbort) opts.signal = fetchAbort.signal;

      fetch(url, opts)
        .then(function (r) {
          var ct = r.headers.get('content-type') || '';
          if (!r.ok || ct.indexOf('application/json') === -1) {
            return r.text().then(function () { throw new Error('Search API returned non-JSON (HTTP ' + r.status + ')'); });
          }
          return r.json();
        })
        .then(function (payload) {
          if (spinner) spinner.hidden = true;
          buildResults(payload);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (spinner) spinner.hidden = true;
          // Show the no-results panel so the user gets feedback rather than silence
          liveZone.innerHTML = '';
          liveZone.hidden = true;
          if (noResultsEl) {
            if (noResultsQuery) noResultsQuery.textContent = '"' + (input.value || '').trim() + '"';
            noResultsEl.hidden = false;
          }
          if (window.console && console.warn) console.warn('Search error:', err && err.message);
        });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (!q) {
        if (suggestions) suggestions.hidden = false;
        liveZone.innerHTML = '';
        liveZone.hidden = true;
        if (noResultsEl) noResultsEl.hidden = true;
        if (spinner) spinner.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        return;
      }
      if (suggestions) suggestions.hidden = true;
      input.setAttribute('aria-expanded', 'true');
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { runQuery(q); }, 220);
    });

    input.addEventListener('keydown', function (e) {
      var options = Array.prototype.slice.call(liveZone.querySelectorAll('[data-search-result]'));
      if (!options.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = e.key === 'ArrowDown'
          ? (activeIndex + 1) % options.length
          : (activeIndex - 1 + options.length) % options.length;
        options.forEach(function (li, i) {
          li.classList.toggle('is-active', i === activeIndex);
        });
        var activeId = options[activeIndex].id;
        input.setAttribute('aria-activedescendant', activeId);
      } else if (e.key === 'Enter') {
        if (activeIndex >= 0) {
          e.preventDefault();
          var href = options[activeIndex].getAttribute('data-search-href');
          if (href) window.location.href = href;
        }
      }
    });

    if (form) form.addEventListener('submit', function (e) {
      var q = (input.value || '').trim();
      if (!q) { e.preventDefault(); return; }
      addRecent(q);
    });
  }

  // ---------- Wishlist (localStorage) ----------
  function initWishlist() {
    var KEY = 'mehak:wishlist';

    // L1 — debounced announce so rapid toggling doesn't flood AT queue
    var announceTimer = null;
    function debouncedAnnounce(msg) {
      clearTimeout(announceTimer);
      announceTimer = setTimeout(function () { announce(msg); }, 250);
    }

    function read() {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
      catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 60))); } catch (e) {}
    }
    function has(handle) {
      return read().some(function (it) { return it.handle === handle; });
    }
    function add(item) {
      var list = read().filter(function (it) { return it.handle !== item.handle; });
      list.unshift(item);
      write(list);
    }
    function remove(handle) {
      write(read().filter(function (it) { return it.handle !== handle; }));
    }

    function updateBadge() {
      var n = read().length;
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
        el.setAttribute('data-count', String(n));
        el.textContent = n > 0 ? String(n) : '';
      });
    }

    function syncCardStates() {
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        var handle = btn.getAttribute('data-wishlist-handle');
        var title = btn.getAttribute('data-wishlist-title') || 'item';
        var pressed = has(handle);
        btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
        btn.classList.toggle('is-active', pressed);
        btn.setAttribute('aria-label', (pressed ? 'Remove ' : 'Add ') + title + (pressed ? ' from wishlist' : ' to wishlist'));
      });
    }

    function renderDrawer() {
      var panel = document.querySelector('[data-wishlist-content]');
      if (!panel) return;
      var list = read();
      var head = '<header class="cart-head">'
        + '<h3>Wishlist' + (list.length > 0 ? ' (' + list.length + ')' : '') + '</h3>'
        + '<button data-wishlist-close aria-label="Close wishlist">'
          + '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
        + '</button></header>';

      if (!list.length) {
        panel.innerHTML = head
          + '<div class="cart-empty">'
            + '<span class="cart-empty__icon" aria-hidden="true">♡</span>'
            + '<h3 class="h3" style="margin:0;">Your wishlist is empty</h3>'
            + '<p>Tap the heart on any piece you love.</p>'
            + '<a class="btn btn--primary" href="/collections/all" data-wishlist-close>Discover the collection</a>'
          + '</div>';
        return;
      }

      var rows = list.map(function (it) {
        var img = it.image ? '<img src="' + escapeAttr(it.image) + '" alt="' + escapeAttr(it.title) + '" loading="lazy">' : '';
        return '<div class="cart-line" data-wishlist-handle-row="' + escapeAttr(it.handle) + '">'
          + '<a href="' + escapeAttr(it.url) + '" class="cart-line__media" data-wishlist-close>' + img + '</a>'
          + '<div class="cart-line__body">'
            + '<div class="cart-line__head">'
              + '<a href="' + escapeAttr(it.url) + '" class="cart-line__title" data-wishlist-close>' + escapeAttr(it.title) + '</a>'
              + '<span class="cart-line__price">' + escapeAttr(it.price || '') + '</span>'
            + '</div>'
            + '<div class="cart-line__bottom">'
              + '<a href="' + escapeAttr(it.url) + '" class="cart-line__link" data-wishlist-close>View product →</a>'
              + '<button type="button" class="cart-line__remove" data-wishlist-remove="' + escapeAttr(it.handle) + '" aria-label="Remove ' + escapeAttr(it.title) + ' from wishlist">'
                + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"/></svg>'
                + '<span>Remove</span>'
              + '</button>'
            + '</div>'
          + '</div>'
        + '</div>';
      }).join('');

      panel.innerHTML = head + '<div class="cart-lines">' + rows + '</div>';
    }

    var wishOverlay = null;
    function getWishOverlay() {
      if (wishOverlay) return wishOverlay;
      var drawer = document.getElementById('WishlistDrawer');
      if (!drawer) return null;
      wishOverlay = manageOverlay({
        container: drawer,
        panel: function (c) { return c.querySelector('.cart-drawer__panel') || c; },
        onOpen: renderDrawer
      });
      return wishOverlay;
    }

    function open(trigger) { var ov = getWishOverlay(); if (ov) ov.open(trigger); }
    function close() { var ov = getWishOverlay(); if (ov) ov.close(); }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-wishlist-open]');
      if (opener) { e.preventDefault(); open(opener); return; }
      if (e.target.closest('[data-wishlist-close]') || e.target.matches('[id="WishlistDrawer"] .cart-drawer__scrim')) {
        close();
      }
      var toggle = e.target.closest('[data-wishlist-toggle]');
      if (toggle) {
        e.preventDefault();
        var handle = toggle.getAttribute('data-wishlist-handle');
        var title = toggle.getAttribute('data-wishlist-title') || 'Item';
        if (has(handle)) {
          remove(handle);
          debouncedAnnounce(title + ' removed from wishlist');  // L1
        } else {
          add({
            handle: handle,
            title: title,
            image: toggle.getAttribute('data-wishlist-image') || '',
            price: toggle.getAttribute('data-wishlist-price') || '',
            url: toggle.getAttribute('data-wishlist-url') || ('/products/' + handle)
          });
          debouncedAnnounce(title + ' added to wishlist');  // L1
        }
        updateBadge();
        syncCardStates();
        renderDrawer();
        return;
      }
      var remBtn = e.target.closest('[data-wishlist-remove]');
      if (remBtn) {
        var h = remBtn.getAttribute('data-wishlist-remove');
        remove(h);
        updateBadge();
        syncCardStates();
        renderDrawer();
        announce('Removed from wishlist');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var ov = getWishOverlay();
        if (ov && ov.isOpen()) close();
      }
    });

    // Render on /pages/wishlist page (if a list mount exists)
    function renderPage() {
      var mount = document.querySelector('[data-wishlist-page]');
      if (!mount) return;
      var list = read();
      if (!list.length) {
        mount.innerHTML = '<div class="wishlist-page__empty"><span aria-hidden="true">♡</span><h2 class="h2">Your wishlist is empty</h2><p class="muted">Tap the heart on any piece you love to save it here.</p><a class="btn btn--primary" href="/collections/all">Discover the collection</a></div>';
        return;
      }
      mount.innerHTML = '<div class="product-grid">' + list.map(function (it) {
        var img = it.image ? '<img src="' + escapeAttr(it.image) + '" alt="" loading="lazy" width="600" height="800">' : '';
        return '<div class="product-card-wrap">'
          + '<a href="' + escapeAttr(it.url) + '" class="product-card">'
            + '<div class="product-card__media">' + img + '</div>'
            + '<div class="product-card__body">'
              + '<h3 class="product-card__title">' + escapeAttr(it.title) + '</h3>'
              + '<p class="product-card__price"><span class="price">' + escapeAttr(it.price || '') + '</span></p>'
            + '</div>'
          + '</a>'
          + '<button type="button" class="product-card__wishlist is-active" data-wishlist-toggle data-wishlist-handle="' + escapeAttr(it.handle) + '" data-wishlist-title="' + escapeAttr(it.title) + '" data-wishlist-image="' + escapeAttr(it.image || '') + '" data-wishlist-price="' + escapeAttr(it.price || '') + '" data-wishlist-url="' + escapeAttr(it.url) + '" aria-pressed="true" aria-label="Remove ' + escapeAttr(it.title) + ' from wishlist">'
            + '<svg class="product-card__wishlist-icon" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 1 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>'
          + '</button>'
        + '</div>';
      }).join('') + '</div>';
    }

    // Re-render the wishlist page when items change (via custom event)
    window.addEventListener('mehak:wishlist:changed', renderPage);

    updateBadge();
    syncCardStates();
    renderPage();
  }

  // ---------- Reel modal (grid + centered modal pattern) ----------
  function initReelsModal() {
    var tiles = Array.prototype.slice.call(document.querySelectorAll('[data-reel-open]'));
    if (!tiles.length) return;
    var modal = document.querySelector('[data-reels-modal]');
    if (!modal) return;

    var video    = modal.querySelector('[data-reels-video]');
    var progress = modal.querySelector('[data-reels-progress]');
    var bufferEl = modal.querySelector('[data-reels-buffer]');
    var muteBtn  = modal.querySelector('[data-reels-mute]');
    var shareBtn = modal.querySelector('[data-reels-share]');
    var prevBtn  = modal.querySelector('[data-reels-prev]');
    var nextBtn  = modal.querySelector('[data-reels-next]');
    var productLink = modal.querySelector('[data-reels-product]');
    var productImg  = modal.querySelector('[data-reels-product-image]');
    var productTitle= modal.querySelector('[data-reels-product-title]');
    var productPrice= modal.querySelector('[data-reels-product-price]');
    var announceEl  = modal.querySelector('[data-reels-announce]');

    var currentIndex = 0;
    var overlay = manageOverlay({
      container: modal,
      panel: function (c) { return c.querySelector('.reels-modal__panel') || c; },
      onClose: function () {
        if (video) { try { video.pause(); } catch (e) {} video.removeAttribute('src'); video.load(); }
        if (progress) progress.style.width = '0%';
      }
    });

    function setProgress(p) {
      if (progress) progress.style.width = (p * 100).toFixed(2) + '%';
    }
    function setBuffering(b) { if (bufferEl) bufferEl.hidden = !b; }

    function loadReel(idx, opts) {
      opts = opts || {};
      var tile = tiles[idx];
      if (!tile) return;
      currentIndex = idx;
      var src   = tile.getAttribute('data-reel-src') || '';
      var title = tile.getAttribute('data-reel-title') || '';
      var poster= tile.getAttribute('data-reel-poster') || '';
      var pUrl  = tile.getAttribute('data-reel-product-url') || '';
      var pTitle= tile.getAttribute('data-reel-product-title') || '';
      var pImg  = tile.getAttribute('data-reel-product-image') || '';
      var pPrice= tile.getAttribute('data-reel-product-price') || '';

      if (video) {
        video.setAttribute('aria-label', title ? 'Reel: ' + title : 'Reel ' + (idx + 1));
        if (poster) video.poster = poster;
        if (src) {
          video.src = src;
          setBuffering(true);
          if (!prefersReducedMotion.matches) {
            var p = video.play();
            if (p && typeof p.then === 'function') p.catch(function(){});
          }
        }
      }
      // H9 — modal accessible name announces the specific reel being watched
      modal.setAttribute('aria-label', (title ? 'Watching: ' + title + ' — ' : 'Watching ') + 'reel ' + (idx + 1) + ' of ' + tiles.length);
      setProgress(0);

      if (productLink) {
        if (pTitle && pUrl) {
          productLink.hidden = false;
          productLink.href = pUrl;
          productLink.setAttribute('aria-label', 'Shop ' + pTitle);
          if (productImg)   { productImg.src = pImg || ''; productImg.alt = pTitle; productImg.style.display = pImg ? '' : 'none'; }
          if (productTitle) productTitle.textContent = pTitle;
          if (productPrice) productPrice.textContent = pPrice || '';
        } else if (pUrl) {
          productLink.hidden = false;
          productLink.href = pUrl;
          if (productTitle) productTitle.textContent = 'View product';
          if (productPrice) productPrice.textContent = '';
          if (productImg)   productImg.style.display = 'none';
        } else {
          productLink.hidden = true;
        }
      }

      if (prevBtn) prevBtn.disabled = idx === 0;
      if (nextBtn) nextBtn.disabled = idx === tiles.length - 1;

      if (!opts.silent && announceEl) {
        announceEl.textContent = 'Reel ' + (idx + 1) + ' of ' + tiles.length + (title ? ': ' + title : '');
      }
    }

    if (video) {
      video.addEventListener('timeupdate', function () {
        if (!video.duration) return;
        setProgress(video.currentTime / video.duration);
      });
      video.addEventListener('waiting', function () { setBuffering(true); });
      video.addEventListener('playing', function () { setBuffering(false); });
      video.addEventListener('click', function () {
        if (video.paused) { video.play().catch(function(){}); }
        else video.pause();
      });
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-reel-open]');
      if (opener) {
        e.preventDefault();
        var idx = parseInt(opener.getAttribute('data-reel-index') || '0', 10) || 0;
        loadReel(idx, { silent: true });
        overlay.open(opener);
        return;
      }
      if (e.target.closest('[data-reels-close]') || e.target.matches('.reels-modal__scrim')) {
        overlay.close();
        return;
      }
      if (e.target.closest('[data-reels-prev]') && currentIndex > 0) {
        loadReel(currentIndex - 1);
        return;
      }
      if (e.target.closest('[data-reels-next]') && currentIndex < tiles.length - 1) {
        loadReel(currentIndex + 1);
        return;
      }
      if (e.target.closest('[data-reels-mute]') && muteBtn && video) {
        // M7 — aria-pressed AND aria-label both flip together.
        // aria-pressed represents current state ("true" = muted). Label is
        // the action the user can take next, so semantically inverted.
        var wasMuted = muteBtn.getAttribute('aria-pressed') === 'true';
        var nowMuted = !wasMuted;
        video.muted = nowMuted;
        muteBtn.setAttribute('aria-pressed', String(nowMuted));
        muteBtn.setAttribute('aria-label', nowMuted ? 'Unmute reel' : 'Mute reel');
        announce(nowMuted ? 'Reel muted' : 'Reel unmuted');
        return;
      }
      if (e.target.closest('[data-reels-share]')) {
        var tile = tiles[currentIndex];
        var t = tile ? (tile.getAttribute('data-reel-title') || '') : '';
        if (navigator.share) {
          navigator.share({ title: 'Check out this look!', text: t, url: window.location.href }).catch(function(){});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(window.location.href).then(function () {
            announce('Link copied to clipboard');
          });
        }
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!overlay.isOpen()) return;
      if (e.key === 'Escape') overlay.close();
      else if (e.key === 'ArrowRight' && currentIndex < tiles.length - 1) loadReel(currentIndex + 1);
      else if (e.key === 'ArrowLeft' && currentIndex > 0) loadReel(currentIndex - 1);
      else if (e.key === ' ') {
        e.preventDefault();
        if (video) { if (video.paused) video.play().catch(function(){}); else video.pause(); }
      }
    });

    // Hover/focus → preview play on grid tiles
    tiles.forEach(function (tile) {
      var v = tile.querySelector('video');
      if (!v) return;
      if (v.getAttribute('data-src') && !v.src) v.src = v.getAttribute('data-src');
      var play = function () {
        if (prefersReducedMotion.matches) return;
        v.play().catch(function(){});
      };
      var pause = function () { try { v.pause(); v.currentTime = 0; } catch (e) {} };
      tile.addEventListener('mouseenter', play);
      tile.addEventListener('focus', play);
      tile.addEventListener('mouseleave', pause);
      tile.addEventListener('blur', pause);
    });
  }

  // ---------- Testimonial auto-advancing carousel ----------
  function initTestiCarousel() {
    var root = document.querySelector('[data-testi-carousel]');
    if (!root) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-testi-slide]'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-testi-dot]'));
    var prev = root.querySelector('[data-testi-prev]');
    var next = root.querySelector('[data-testi-next]');
    var pp   = root.querySelector('[data-testi-playpause]');
    var interval = parseInt(root.getAttribute('data-autoplay') || '4000', 10);
    var current = 0;
    var timer = null;
    var playing = !prefersReducedMotion.matches && interval > 0;

    function show(i, opts) {
      opts = opts || {};
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) {
        var on = idx === current;
        s.hidden = !on;
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (d, idx) {
        var on = idx === current;
        d.classList.toggle('is-active', on);
        if (on) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      if (opts.announce) {
        var name = slides[current].querySelector('.testi__name');
        announce('Testimonial ' + (current + 1) + ' of ' + slides.length + (name ? ': ' + name.textContent : ''));
      }
    }

    function tick() { show(current + 1); }
    function start() {
      if (!playing || timer) return;
      timer = setInterval(tick, interval);
      if (pp) { pp.setAttribute('aria-pressed', 'true'); pp.setAttribute('aria-label', 'Pause auto-advance'); }
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
      if (pp) { pp.setAttribute('aria-pressed', 'false'); pp.setAttribute('aria-label', 'Play auto-advance'); }
    }

    if (prev) prev.addEventListener('click', function () { show(current - 1, { announce: true }); stop(); });
    if (next) next.addEventListener('click', function () { show(current + 1, { announce: true }); stop(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var idx = parseInt(d.getAttribute('data-testi-dot') || '0', 10) || 0;
        show(idx, { announce: true });
        stop();
      });
    });
    if (pp) pp.addEventListener('click', function () {
      if (timer) { playing = false; stop(); }
      else { playing = true; start(); }
    });

    // Pause on hover + focus-within
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', function () { if (playing) start(); });
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget) && playing) start();
    });

    // Pause when tab hidden
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else if (playing) start();
    });

    show(0);
    if (playing) start();
  }

  // ---------- Client diaries lightbox carousel ----------
  function initDiariesLightbox() {
    var triggers = document.querySelectorAll('[data-diary-open]');
    if (!triggers.length) return;
    var modal = document.querySelector('[data-diary-modal]');
    if (!modal) return;
    var stage = modal.querySelector('[data-diary-stage]');
    var counter = modal.querySelector('[data-diary-counter]');
    var prev = modal.querySelector('[data-diary-prev]');
    var next = modal.querySelector('[data-diary-next]');
    var entries = [];
    triggers.forEach(function (t) {
      entries.push({
        image: t.getAttribute('data-diary-image'),
        name:  t.getAttribute('data-diary-name'),
        role:  t.getAttribute('data-diary-role'),
        quote: t.getAttribute('data-diary-quote'),
        badge: t.getAttribute('data-diary-badge')
      });
    });
    var current = 0;

    function render() {
      var e = entries[current];
      if (!stage) return;
      stage.innerHTML =
        '<figure class="diary-modal__figure">'
          + (e.image ? '<img src="' + escapeAttr(e.image) + '" alt="">' : '')
        + '</figure>'
        + '<aside class="diary-modal__aside">'
          + (e.badge ? '<span class="diary-modal__badge">' + escapeAttr(e.badge) + '</span>' : '')
          + (e.quote ? '<blockquote class="diary-modal__quote"><p>' + escapeAttr(e.quote) + '</p></blockquote>' : '')
          + '<p class="diary-modal__byline"><strong>' + escapeAttr(e.name || '') + '</strong>' + (e.role ? ' <span class="muted">— ' + escapeAttr(e.role) + '</span>' : '') + '</p>'
        + '</aside>';
      if (counter) counter.textContent = (current + 1) + ' / ' + entries.length;
    }

    var overlay = manageOverlay({
      container: modal,
      panel: function (c) { return c.querySelector('.diary-modal__panel') || c; },
      onOpen: render
    });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-diary-open]');
      if (trigger) {
        e.preventDefault();
        current = Array.prototype.indexOf.call(triggers, trigger);
        if (current < 0) current = 0;
        overlay.open(trigger);
        return;
      }
      if (e.target.closest('[data-diary-close]') || e.target.matches('.diary-modal__scrim')) overlay.close();
      if (e.target.closest('[data-diary-prev]')) { current = (current - 1 + entries.length) % entries.length; render(); }
      if (e.target.closest('[data-diary-next]')) { current = (current + 1) % entries.length; render(); }
    });
    document.addEventListener('keydown', function (e) {
      if (!overlay.isOpen()) return;
      if (e.key === 'Escape') overlay.close();
      if (e.key === 'ArrowLeft') { current = (current - 1 + entries.length) % entries.length; render(); }
      if (e.key === 'ArrowRight') { current = (current + 1) % entries.length; render(); }
    });
  }

  // ---------- Free shipping bar in cart drawer ----------
  function initFreeShipBar() {
    var THRESHOLD = parseInt((document.body.dataset.freeShipMin || '300000'), 10);
    // C3 — renderCart dispatches on window, listen there.
    window.addEventListener('mehak:cart:rendered', function (e) {
      var data = e.detail || cartState;
      var panel = document.querySelector('[data-cart-content]');
      if (!panel || !data) return;
      var existing = panel.querySelector('[data-free-ship-bar]');
      if (existing) existing.remove();
      if (!data.items || !data.items.length) return;
      var total = data.total_price || 0;
      var remaining = THRESHOLD - total;
      var pct = Math.min(100, Math.round((total / THRESHOLD) * 100));
      var msg = remaining > 0
        ? 'Add ' + formatMoney(remaining) + ' more for free shipping'
        : 'You qualify for free shipping ✓';
      var bar = document.createElement('div');
      bar.className = 'free-ship-bar' + (remaining <= 0 ? ' free-ship-bar--earned' : '');
      bar.setAttribute('data-free-ship-bar', '');
      bar.innerHTML =
        '<p class="free-ship-bar__msg">' + msg + '</p>'
        + '<div class="free-ship-bar__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="Progress toward free shipping">'
          + '<div class="free-ship-bar__fill" style="width:' + pct + '%"></div>'
        + '</div>';
      var head = panel.querySelector('.cart-head');
      if (head && head.nextSibling) head.parentNode.insertBefore(bar, head.nextSibling);
    });
  }

  // ---------- Header scroll state (transparent → solid) ----------
  // Only meaningful on the home page; non-home templates always render the
  // solid #1C1B1B header via CSS, no scroll tracking needed.
  function initHeaderScrollState() {
    if (!document.body.classList.contains('template-index')) {
      document.body.classList.remove('is-scrolled');
      return;
    }
    var threshold = 60;
    var ticking = false;
    function apply() {
      var scrolled = window.scrollY > threshold;
      document.body.classList.toggle('is-scrolled', scrolled);
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(apply);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    apply();
  }

  // ---------- Filter dual-range price slider ----------
  function initFilterPriceRange() {
    document.querySelectorAll('[data-filter-price]').forEach(function (root) {
      var floor   = parseInt(root.getAttribute('data-floor') || '0', 10);
      var ceiling = parseInt(root.getAttribute('data-ceiling') || '100000', 10);
      var minRange = root.querySelector('[data-filter-price-min-range]');
      var maxRange = root.querySelector('[data-filter-price-max-range]');
      var minInput = root.querySelector('[data-filter-price-min-input]');
      var maxInput = root.querySelector('[data-filter-price-max-input]');
      var fill     = root.querySelector('[data-filter-price-fill]');
      if (!minRange || !maxRange) return;

      function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

      // Thumb radius — must match .filter-price__handle::-webkit-slider-thumb width / 2 in CSS.
      var THUMB_RADIUS_PX = 10;

      // Map a 0..100 percentage to a CSS calc that lands exactly at the thumb center.
      // A native <input type=range> places the thumb center at `radius` (when value=min)
      // and at `(trackWidth - radius)` (when value=max). So thumb-center =
      //   radius + (pct/100) * (trackWidth - 2*radius)
      // In CSS calc:
      //   pct% - (pct/100)*2*radius + radius   ==   pct% - pct*0.2px + 10px (when radius=10)
      function thumbCenterFromLeft(pct) {
        return 'calc(' + pct + '% - ' + (pct * (2 * THUMB_RADIUS_PX) / 100) + 'px + ' + THUMB_RADIUS_PX + 'px)';
      }
      function thumbCenterFromRight(pct) {
        var inv = 100 - pct;
        return 'calc(' + inv + '% - ' + (inv * (2 * THUMB_RADIUS_PX) / 100) + 'px + ' + THUMB_RADIUS_PX + 'px)';
      }

      function syncFill() {
        var minV = parseFloat(minRange.value);
        var maxV = parseFloat(maxRange.value);
        var span = ceiling - floor || 1;
        var leftPct  = ((minV - floor) / span) * 100;
        var rightPct = ((maxV - floor) / span) * 100;
        if (fill) {
          fill.style.left  = thumbCenterFromLeft(leftPct);
          fill.style.right = thumbCenterFromRight(rightPct);
        }
        minRange.setAttribute('aria-valuetext', '₹' + Math.round(minV).toLocaleString('en-IN'));
        maxRange.setAttribute('aria-valuetext', '₹' + Math.round(maxV).toLocaleString('en-IN'));
      }

      var lastAnnouncedClamp = 0;
      function fromRange() {
        var minV = parseFloat(minRange.value);
        var maxV = parseFloat(maxRange.value);
        var step = parseFloat(minRange.step) || 1;
        var didClamp = false;
        if (minV > maxV - step) {
          if (this === minRange) minV = maxV - step;
          else                   maxV = minV + step;
          minRange.value = minV;
          maxRange.value = maxV;
          didClamp = true;
        }
        if (minInput) minInput.value = Math.round(minV);
        if (maxInput) maxInput.value = Math.round(maxV);
        syncFill();
        // M4 — announce only on actual clamp event (throttled 800ms)
        if (didClamp && Date.now() - lastAnnouncedClamp > 800) {
          lastAnnouncedClamp = Date.now();
          announce('Range adjusted: ₹' + Math.round(minV).toLocaleString('en-IN') + ' to ₹' + Math.round(maxV).toLocaleString('en-IN'));
        }
      }

      function fromInput(which) {
        var v = parseInt((which.value || '').replace(/[^\d-]/g, ''), 10);
        if (isNaN(v)) return;
        v = clamp(v, floor, ceiling);
        if (which === minInput) {
          var maxV = parseFloat(maxRange.value);
          if (v > maxV) v = maxV;
          minRange.value = v;
        } else {
          var minV = parseFloat(minRange.value);
          if (v < minV) v = minV;
          maxRange.value = v;
        }
        syncFill();
      }

      minRange.addEventListener('input', fromRange);
      maxRange.addEventListener('input', fromRange);
      if (minInput) {
        minInput.addEventListener('change', function () { fromInput(minInput); });
        minInput.addEventListener('blur',   function () { fromInput(minInput); });
      }
      if (maxInput) {
        maxInput.addEventListener('change', function () { fromInput(maxInput); });
        maxInput.addEventListener('blur',   function () { fromInput(maxInput); });
      }
      syncFill();
    });
  }

  // ---------- Responsive helpers ----------
  function initResponsive() {
    var desktopMQ = window.matchMedia('(min-width: 1024px)');
    function handleResize() {
      // Force-close mobile nav when viewport upgrades to desktop, where the toggle is hidden
      var nav = document.getElementById('MobileNav');
      if (desktopMQ.matches && nav && nav.getAttribute('aria-hidden') === 'false') {
        nav.setAttribute('aria-hidden', 'true');
        nav.hidden = true;
        document.body.style.overflow = '';
        var toggle = document.querySelector('[data-menu-open]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
      // Reset hamburger aria-expanded if it's hidden at desktop
      var toggle = document.querySelector('[data-menu-open]');
      if (toggle && desktopMQ.matches) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    }
    if (desktopMQ.addEventListener) desktopMQ.addEventListener('change', handleResize);
    else if (desktopMQ.addListener) desktopMQ.addListener(handleResize);
    handleResize();
  }

  // ---------- Boot ----------
  function boot() {
    initResponsive();
    initHeaderScrollState();
    initMobileNav();
    initHeaderDropdowns();
    initCart();
    initReels();
    initReelGridAutoplay();
    initProductForm();
    initGallery();
    initLightbox();
    initStickyBuy();
    initFallbackSize();
    initQtyStepper();
    initSizeChart();
    initRecentlyViewed();
    initReviewsMore();
    initReveal();
    initHeroVideo();
    initHeroCarousel();
    initSearchOverlay();
    initWishlist();
    initReelsModal();
    initTestiCarousel();
    initFreeShipBar();
    initFilterPriceRange();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
